module.exports = __webpack_public_path__ + "static/img/06.72623aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/06.png
// module id = eM4x
// module chunks = 1